import { formatMoney } from 'utils';

class StickyAtc extends HTMLElement {
  #observer;
  #boundOnMainVariantChange;
  #sectionId;

  connectedCallback() {
    this.#sectionId = this.dataset.sectionId;
    this.priceEl = this.querySelector('.sticky-atc__price');
    this.btn = this.querySelector('.sticky-atc__btn');

    const atcTarget = document.querySelector('.js-product-buttons');
    if (atcTarget) {
      this.#observer = new IntersectionObserver(([entry]) => this.#onIntersect(entry), { threshold: 0 });
      this.#observer.observe(atcTarget);
    }

    setTimeout(() => {
      const mainVarSelector = document.querySelector(
        `variant-radios[data-section="${this.#sectionId}"]:not([data-card]),` +
          `variant-selects[data-section="${this.#sectionId}"]:not([data-card]),` +
          `variant-mixed-inputs[data-section="${this.#sectionId}"]:not([data-card])`,
      );
      if (mainVarSelector) {
        this.#boundOnMainVariantChange = this.#onMainVariantChange.bind(this);
        mainVarSelector.addEventListener('on:variant:change', this.#boundOnMainVariantChange);
      }

      const modal = document.getElementById(`sticky-atc-${this.#sectionId}-modal`);
      modal?.addEventListener('on:modal:opening', () => this.#syncModalVariant(modal));
    });

    this.querySelector('[data-sticky-atc-direct]')?.addEventListener('click', () => {
      this.#submitMainForm();
    });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    if (this.#boundOnMainVariantChange) {
      const mainVarSelector = document.querySelector(
        `variant-radios[data-section="${this.#sectionId}"]:not([data-card]),` +
          `variant-selects[data-section="${this.#sectionId}"]:not([data-card]),` +
          `variant-mixed-inputs[data-section="${this.#sectionId}"]:not([data-card])`,
      );
      mainVarSelector?.removeEventListener('on:variant:change', this.#boundOnMainVariantChange);
    }
  }

  #onIntersect(entry) {
    const show = !entry.isIntersecting;
    this.setAttribute('aria-hidden', String(!show));
    this.classList.toggle('is-visible', show);
  }

  #onMainVariantChange(event) {
    const { variant } = event.detail;
    if (!variant) return;

    if (this.priceEl) {
      this.priceEl.innerHTML = `<span class="money">${formatMoney(variant.price, window.theme.money_product_price_format)}</span>`;
    }

    if (this.btn) {
      this.btn.disabled = !variant.available;
    }
  }

  #syncModalVariant(modal) {
    const mainForm = document.getElementById(`product-form-${this.#sectionId}`);
    const variantId = parseInt(mainForm?.querySelector('input[name="id"]')?.value);
    if (!variantId) return;

    modal.querySelector('product-interactive-options')?.selectVariantById(variantId);
  }

  #submitMainForm() {
    document
      .getElementById(`product-form-${this.#sectionId}`)
      ?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
}

customElements.define('sticky-atc', StickyAtc);
